import { ActivationScreenEvents } from '../../Typescript'
import { getBrandName, getLocationUrl } from '../../Utils'
import { BrandName } from '../../Typescript'
import AppMeasurements from '../../Services/AppMeasurements'
import Config from '../../Data/Config.json'

export class TVEDeviceConfig {
    getConfig() {
        const isDev = process.env.REACT_APP_CONFIG_ENV === 'dev'
        const apiConfig = isDev ? Config.viewlift.apiConfig.dev : Config.viewlift.apiConfig.prod
        const tveClientDomain = isDev
            ? Config.viewlift.tveClientDomain.dev
            : Config.viewlift.tveClientDomain.prod
        const locationUrl = getLocationUrl()
        const applicationId = getBrandName() === BrandName.cnbc ? 'CNBC' : 'MSNOW'
        return {
            apiConfig: apiConfig,
            mediaInfo: {
                tveBannerUrl: 'https://lightning.cnbc.com/tizen/static/cnbc/splash_fhd.png',
                tveBannerAltDescription: 'Provider logo',
            },
            authSetting: {
                applicationId,
                isTveAuth: true,
                uppercaseActivationCode: true,
                eventsCallback: {
                    onProviderModalDisplay: () => {
                        const trackEventData = {
                            trackEventType: ActivationScreenEvents.mvpdSelection,
                        }
                        AppMeasurements.trackAuthEvent(trackEventData)
                    },
                    beforeProviderRedirect: (mvpdData: { title: string; identifier: string }) => {
                        const trackEventData = {
                            trackEventType: ActivationScreenEvents.mvpdSelected,
                            mvpdId: mvpdData.identifier,
                        }
                        AppMeasurements.trackAuthEvent(trackEventData)
                    },
                },
            },
            metadataMap: {
                activateTveeWebTitle: 'Activate your Device', // cspell:disable-line
                activateTveWebSubTitle: 'Enter the activation code to start watching',
                activatePlaceholderText: ' ',
                buttonText: 'Go',
                caseSensitiveTooltip: 'This code is case sensitive',
                chooseProvderTxt: 'Choose Your TV Provider', // cspell:disable-line,
                errorMessages: {
                    GENERIC: 'Invalid activation code. Please try again later.',
                    TVE_PROVIDER_ERROR: 'Error loading TVE provider. Please retry.',
                    USER_ALREADY_LOGGED_IN: 'User is already logged in.',
                },
            },
            styleInfo: {
                moduleBackgroundColor: '#ffff',
                moduleTextColor: '#666',
                moduleHeight: '220px',
                moduleWidth: '100%',
                inputBorderColor: '#666',
                validateCtaBgColor: '#b0b9bd',
                validateCtaTextColor: '#ffff',
            },
            // Adds 'debug,Config' only on localhost to handle redirect using whitelisted domains, since localhost is not part of the allowed whitelist.
            debugConfig: {
                tveRedirectUrl: `${locationUrl}complete`,
                tveRedirectAuthQueryParam: 'sessionAuthStatus',
                tveClientDomain: tveClientDomain,
            },
        }
    }
}

export default TVEDeviceConfig
